export default __webpack_public_path__ + "empty-clock.43efb908.svg";